export default "__VITE_ASSET__C8nZc8jl__"